export default __webpack_public_path__ + "static/media/824.077a48d2.gif";